import { mapKeys } from 'lodash'

import { LOAN_PURPOSE_LIST } from 'embed/constants'
import { brandFromHost } from 'embed/constants/config'
import { DEFAULT_THEME } from 'embed/constants/theme'
import {
  Config,
  ConfigServiceDataKeys,
  LoanPurposeOptions,
  QueryParamKeys,
  THEME_QUERY_PARAM_PREFIX,
} from 'even-ts-static'

const brand = brandFromHost
export const DEFAULT_CONFIG: Config = {
  ...mapKeys(DEFAULT_THEME, (value, key) => `${THEME_QUERY_PARAM_PREFIX}${key}`),

  [ConfigServiceDataKeys.brand]: brand,
  [ConfigServiceDataKeys.partner]: brand,
  [ConfigServiceDataKeys.shouldAutoRedirect]: true,
  [ConfigServiceDataKeys.shouldDisplayNavigation]: false,
  [QueryParamKeys.MaxResults]: 10,
  [ConfigServiceDataKeys.loanPurposeOptions]: LOAN_PURPOSE_LIST.filter(
    (options) => options.value !== LoanPurposeOptions.STUDENT_REFINANCE,
  ).map((option) => option.value) as LoanPurposeOptions[],
}
